import {ISelectOption} from '../interface/selectOption'

const groupByFields = (array: Array<any>, f: any): Array<any> => {
  /*
    params description :
        f : function which returnf the array of fields 
        e.g. :  (item) => {
            return [itemField1, itemField2];
        }
        array : array of data to group e.g. : [{...}, {...}]       
    */
  let groups: {[key: string]: any[]} = {}
  array.forEach((o) => {
    let group = JSON.stringify(f(o))
    groups[group] = groups[group] || []
    groups[group].push(o)
  })

  return Object.keys(groups).map((group) => {
    return groups[group]
  })
}

/**
 * split array into chunks
 * @param array - array to split
 * @param chunkSize - chunk size
 * @returns
 */
const splitArray = <T>(array: Array<T>, chunkSize: number) => {
  const chunks = Array(Math.ceil(array.length / chunkSize))
    .fill(1)
    .map((_, index) => index * chunkSize)
    .map((begin) => array.slice(begin, begin + chunkSize))
  return chunks
}

/**
 * Get values from options
 * @param options
 * @returns
 */
const getValuesFromOptions = (options: ISelectOption[]) => {
  return options.map((x) => x.value)
}

export {groupByFields, splitArray, getValuesFromOptions}
